import React from 'react'
import ReactDOM from 'react-dom/client'
import {
  BrowserRouter, Routes as ReactRouterRoutes, Route,
  matchRoutes, createRoutesFromChildren, useNavigationType, useLocation, Navigate
} from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import loadable from '@loadable/component'
import './index.scss'
import config from 'config'
import App from './App'
import ScrollToTop from 'components/ScrollToTop'
import { HelmetProvider } from 'react-helmet-async'
const ErrorBoundaryFallback = loadable(() => import('components/ErrorBoundaryFallback'))
const NotFound = loadable(() => import('routes/NotFound'))
const Track = loadable(() => import('routes/Track'))
const Order = loadable(() => import('routes/Order'))

const nodeEnv = process.env.NODE_ENV

Sentry.init({
  dsn: config.sentry.dsn,
  environment: nodeEnv,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      )
    })
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We (Sentry) recommend adjusting this value in production
  tracesSampleRate: nodeEnv === 'production' ? 1.0 : 0
})

const RoutesComponent = Sentry.withSentryReactRouterV6Routing(ReactRouterRoutes)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={ props => <ErrorBoundaryFallback { ...props } /> }
      showDialog={ true }>
      <HelmetProvider>
        <BrowserRouter>
          {/* scroll to top every time the location pathname changes */}
          <ScrollToTop />

          <RoutesComponent>
            {/* / */}
            <Route element={ <App /> }>
              {/* redirect from / to /track */}
              <Route index
                element={
                  <Navigate to='/track' replace={ true } />
                } />

              {/* /track */}
              <Route path='track'>
                <Route index element={ <Track /> } />
              </Route>

              {/* /order */}
              <Route path='order'>
                <Route index element={ <Order /> } />
              </Route>

              {/* handle "no match" */}
              <Route path='*'element={ <NotFound /> } />
            </Route>
          </RoutesComponent>
        </BrowserRouter>
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
